<template>
  <div class="main-box">
    <div class="header">
      <div class="bg_header">
        <div style="display: flex; align-items: center; width: 23vw">
          <div class="loginTitleimg">
            <img v-if="titleLogo" :src="titleLogo" alt="" class="img1" />
          </div>
          <div class="index-title" @click="goHome" style="cursor: pointer">{{ waterName || '智慧环境大数据平台' }}</div>
        </div>

        <div class="tab-content">
          <div class="tab-item" v-for="(item, index) in tabList" :key="index" @click="onToTab(item.id, index)">
            <span
              :class="[selectIndex == index ? 'selectColor' : '']"
              style="
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              "
              >{{ item.name }}
              <transition name="show">
                <img
                  class="traImg"
                  v-if="selectIndex == index"
                  src="../../assets/others/index/top-current.png"
                  alt=""
                />
              </transition>
            </span>
            <span v-if="index != tabList.length - 1" style="margin-left: 20px">/</span>
          </div>
        </div>
      </div>
      <div class="bg-header-right">
        <div class="right-box">
          <div class="dateBox">
            <div class="date">{{ headDate }}</div>
            <div class="time">{{ headTime }}</div>
          </div>
          <a-icon
            type="home"
            title="回到首页"
            style="color: aqua; font-size: 1.6rem; margin-right: 20px"
            @click="goHome"
          />
          <a-icon
            v-if="!isFullscreen"
            type="fullscreen"
            style="color: aqua; font-size: 1.6rem; margin-right: 20px"
            title="全屏"
            @click="fullscreen"
          />
          <a-icon
            v-else
            type="fullscreen-exit"
            style="color: aqua; font-size: 1.6rem; margin-right: 20px"
            title="退出全屏"
            @click="fullscreen"
          />
          <a-icon type="logout" title="退出登录" style="color: aqua; font-size: 1.6rem" @click="logout" />
        </div>
      </div>

      <!-- <div style="position: absolute; right: 20px; top: 10px; cursor: pointer" @click="fullscreen">
        <a-icon v-if="!isFullscreen" type="fullscreen" style="color: aqua; font-size: 20px" />
        <a-icon v-else type="fullscreen-exit" style="color: aqua; font-size: 20px" />
      </div> -->
    </div>
    <!-- 驾驶舱 -->
    <cockpit @siteTurn="turnTosite" v-if="selectId == 0"></cockpit>
    <!-- 环境质量一张图 -->
    <atmosphere :tabList="atmosphereList" @siteTurn="turnTosite" v-if="selectId == 1"></atmosphere>
    <!-- 污染源一张图 -->
    <water-quality :tabList="waterQualityList" @siteTurn="turnTosite" v-if="selectId == 2"></water-quality>
    <!-- 水文气象一张图 -->
    <hydrology :tabList="hydrologyList" @siteTurn="turnTosite" v-if="selectId == 3"></hydrology>
    <!-- 工况一张图 -->
    <working :tabList="workingList" @siteTurn="turnTosite" v-if="selectId == 4"></working>
    <!-- 站点一张图 -->
    <file v-if="selectId == 5 && !isYongChun"></file>
    <yong-chun-file v-if='selectId == 5 && isYongChun'></yong-chun-file>
  </div>
</template>
<script>
// 各子组件引入
import cockpit from './tab/cockpit'
import atmosphere from './tab/atmosphere'
import hydrology from './tab/hydrology'
import working from './tab/working'
import waterQuality from './tab/waterQuality'
import file from './tab/file'
import yongChunFile from "@/views/yongchun/dashboard/tab/file.vue"
import moment from 'moment'
import { mapActions } from 'vuex'
import { queryTenant, queryTabList, queryMapTab, queryBigDataById,getTenantStByToken } from '@/api/api'
import { isYongChun } from '@/utils/util'
// 全屏
import screenfull from 'screenfull'
export default {
  components: {
    cockpit,
    atmosphere,
    hydrology,
    working,
    waterQuality,
    file,
    yongChunFile
  },
  data() {
    return {
      titleLogo: '',
      waterName: '',
      headDate: '',
      headTime: '',
      selectIndex: -1,
      selectId: -1,
      isFullscreen: false,
      atmosphereList: [], //环境质量一张图tab
      waterQualityList: [], //污染源一张图tab
      hydrologyList: [], //水文气象一张图tab
      workingList: [], //工况一张图tab
      atmosphereIndex: '',
      waterQualityIndex: '',
      hydrologyIndex: '',
      workingIndex: '',
      tabList: [
        // {
        //   id: 0,
        //   name: '驾驶舱',
        // },
        // {
        //   id: 1,
        //   name: '环境质量一张图',
        // },
        // {
        //   id: 2,
        //   name: '污染源一张图',
        // },
        // {
        //   id: 3,
        //   name: '水文气象一张图',
        // },
        // {
        //   id: 4,
        //   name: '工况一张图',
        // },
        // {
        //   id: 5,
        //   name: '站点一张图',
        // }
      ],
      isYongChun: false,
    }
  },
  created() {
    console.log('enter')
    this.titleLogo = window.localStorage.getItem('titleLogo')
    this.waterName = window.localStorage.getItem('waterName')
    // var reg = new RegExp('(^|&)tab=([^&]*)(&|$)')
    // var r = window.location.search.substr(1).match(reg)
    // 获取顶部导航栏配置菜单
    this.getTablist()
    //   if (window.localStorage.getItem('tenant') == 2) {
    // this.selectIndex = 2
    //     this.tabList = [
    //       // {
    //       //   id: 0,
    //       //   name: '驾驶舱',
    //       // },
    //       {
    //         id: 2,
    //         name: '污染源一张图',
    //       },
    //       {
    //         id: 5,
    //         name: '站点一张图',
    //       },
    //     ]
    //   }
    this.isYongChun = isYongChun()
    if (this.$route.query && this.$route.query.selectId) {
      queryBigDataById({
        id: this.$route.query.selectId,
      }).then((res) => {
        if (res.success) {
          sessionStorage.setItem('selectId', JSON.stringify(res.result))
          setTimeout(() => {
            this.turnTosite(true)
          }, 100)
        }
      })
    }
  },
  mounted() {
    setInterval(() => {
      var date = new Date()
      this.headDate = moment(date).format('YYYY年MM月DD日')
    }, 60000)
    this.getDate()
  },
  methods: {
    getMaptab() {
      this.initTenantInfo().then(res1 => {
        let stList = res1.st.split(',')
        queryMapTab({
        pageNo: 1,
        pageSize: 100,
        status: 1
      }).then((res) => {
        if (res.success && res.result && res.result.records.length > 0) {
          let arr = res.result.records.filter(item=>stList.includes(item.code))
          console.log('arr',arr)
          arr.forEach((item, index) => {
            let obj = {}
            obj.name = item.abbreviation
            obj.st = String(item.code)
            obj.iconfont = item.icon
            switch (item.category) {
              case '1':
                this.atmosphereList.push(obj)
                break
              case '2':
                this.waterQualityList.push(obj)
                break
              case '3':
                this.hydrologyList.push(obj)
                break
              case '4':
                this.workingList.push(obj)
                break
            }

          })
          let state = false
          for(let i =0;i<arr.length;i++){
            let item = arr[i]
            if(this.$store.getters.userInfo.st && (this.$store.getters.userInfo.st==String(item.id))){
              this.tabList.forEach((item1,index)=>{
                item1.id==item.category?this.selectIndex = index:''
              })
              this.selectId = item.category
              state = true
              break;
            }
          }
          !state?this.initTabSelected():''
          console.log('atmosphereList',this.$store.getters.userInfo)
          console.log('atmosphereList',this.selectIndex)
        }else{
          this.initTabSelected()
        }
      }).catch(()=>{
        this.initTabSelected()
      })
      })

      
    },
    initTabSelected(){
      this.selectIndex = 0
      this.selectId = this.tabList[this.selectIndex].id
      if (this.$route.query.tab) {
        this.selectIndex = this.tabList.length - 1
        this.selectId = this.tabList[this.selectIndex].id
        this.$router.replace({
          query: '',
        })
      }
    },
    getTablist() {
      queryTabList().then((res) => {
        // this.tabList.push(
        // 	{
        // 	  id: 0,
        // 	  name: '驾驶舱',
        // 	}
        // 	)
        if (res.length > 0) {
          res.forEach((item, index) => {
            switch (item) {
              // case '0':
              // 	this.tabList.push(
              // 	{
              // 	  id: 0,
              // 	  name: '驾驶舱',
              // 	}
              // 	)
              // 	break;
              case '1':
                this.tabList.push({
                  id: 1,
                  name: '环境质量一张图',
                })
                break
              case '2':
                this.tabList.push({
                  id: 2,
                  name: '污染源一张图',
                })
                break
              case '3':
                this.tabList.push({
                  id: 3,
                  name: '水文气象一张图',
                })
                break
              case '4':
                this.tabList.push({
                  id: 4,
                  name: '工况一张图',
                })
                break
              // case '5':
              // 	this.tabList.push(
              // 	{
              // 	  id: 5,
              // 	  name: '站点一张图',
              // 	}
              // 	)
              // 	break;
            }
          })
          console.log(this.tabList)
        }
        this.tabList.push({
          id: 5,
          name: '站点一张图',
        })

        // 获取每个一张图对应的tab部分
        this.getMaptab()
      })
      //   queryTenant().then((res) => {
      //     if (res.success && res.result && res.result.records.length > 0) {
      //       switch (res.result.records[0].tenantId) {
      //         case 2:
      //           this.tabList = [
      //             {
      //               id: 2,
      //               name: '污染源一张图',
      //             },
      // 				{
      // 				  id: 1,
      // 				  name: '环境质量一张图',
      // 				},
      //             {
      //               id: 5,
      //               name: '站点一张图',
      //             },
      //           ]
      //           this.selectIndex = 0
      //  this.selectId = this.tabList[this.selectIndex].id
      //           if (this.$route.query.tab) {
      //             this.selectIndex = this.tabList.length-1
      // this.selectId = this.tabList[this.selectIndex].id
      //             this.$router.replace({ query: '' })
      //           }
      //           break
      //         default:
      //           this.tabList = [
      //             // {
      //             //   id: 0,
      //             //   name: '驾驶舱',
      //             // },
      //             {
      //               id: 1,
      //               name: '环境质量一张图',
      //             },
      //             {
      //               id: 2,
      //               name: '污染源一张图',
      //             },
      //             {
      //               id: 3,
      //               name: '水文气象一张图',
      //             },
      //             {
      //               id: 4,
      //               name: '工况一张图',
      //             },
      //             {
      //               id: 5,
      //               name: '站点一张图',
      //             },
      //           ]
      //           this.selectIndex = 0
      //           this.selectId = this.tabList[this.selectIndex].id
      //           if (this.$route.query.tab) {
      //            this.selectIndex = this.tabList.length-1
      //            this.selectId = this.tabList[this.selectIndex].id
      //             this.$router.replace({ query: '' })
      //           }
      //           break
      //       }
      //     }
      //   })
    },
    turnTosite(value) {
      if (value) {
        // for (let i = 0; i < this.tabList.length; i++) {
        // if (this.tabList[i].name == '站点一张图') {
        this.selectIndex = this.tabList.length - 1
        this.selectId = this.tabList[this.selectIndex].id
        // }
        // }
      }
    },
    getDate() {
      var date = new Date()
      this.headDate = moment(date).format('YYYY年MM月DD日')
      this.headTime = moment(date).format('HH:mm:ss')
      setInterval(() => {
        var time = new Date()
        this.headTime = moment(time).format('HH:mm:ss')
        this.$forceUpdate()
      }, 1000)
    },
    // 点击头部导航栏
    onToTab(id, index) {
      this.selectIndex = index
      this.selectId = id
      let data
      switch (id) {
        case 1:
          data = JSON.parse(JSON.stringify(this.atmosphereList))
          this.atmosphereList = []
          this.$nextTick(() => {
            this.atmosphereList = data
          })
          break
        case 2:
          data = JSON.parse(JSON.stringify(this.waterQualityList))
          this.waterQualityList = []
          this.$nextTick(() => {
            this.waterQualityList = data
          })
          break
        case 3:
          data = JSON.parse(JSON.stringify(this.hydrologyList))
          this.hydrologyList = []
          this.$nextTick(() => {
            this.hydrologyList = data
          })
          break
        case 4:
          data = JSON.parse(JSON.stringify(this.workingList))
          this.workingList = []
          this.$nextTick(() => {
            this.workingList = data
          })
          break
      }
    },
    fullscreen() {
      screenfull.toggle()
      this.isFullscreen = !this.isFullscreen
    },
    goHome() {
      if(window.localStorage.getItem('projectCode') == 'yongchun'){
        this.$router.push('/monitor/mapYc')
      }else{
        this.$router.push('/monitor/map')
      }

    },
    ...mapActions(['Logout','initTenantInfo']),
    logout() {
      const that = this

      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk() {
          return that
            .Logout({})
            .then(() => {
              window.location.href = '/'
              //window.location.reload()
            })
            .catch((err) => {
              that.$message.error({
                title: '错误',
                description: err.message,
              })
            })
        },
        onCancel() {},
      })
    },
  },
}
</script>

<style type="text/css" scoped>
.main-box {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-image: url(../../assets/others/index/index.png);
  background-size: 100% 100%;
  overflow: hidden;
}

.header {
  width: 100%;
  height: 4.5vw;
  /* padding: 0 20px; */
  /*min-width: 1713px;*/
  display: flex;
  position: relative;
  z-index: 1000;
  justify-content: space-between;
}

.loginTitleimg {
  position: relative;
  margin-left: 10px;
  /* margin-right: 5px; */
}

.img1 {
  /* position: absolute; */
  top: 10px;
  left: 10px;
  /*width: 40px;*/
  height: 40px;
  /* margin-right: 20px; */
}

.img2 {
  width: 65px;
  height: 65px;
}

.bg_header {
  width: 77%;
  height: 4.5vw;
  min-height: 61px;
  background: url(../../assets/others/index/title.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
}

.bg-header-right {
  width: 20%;
  height: 4.5vw;
  background: url(../../assets/others/index/top-right.png) no-repeat;
  background-size: 100% 100%;
}

.logo {
  width: 70px;
  height: 70px;
  /* margin-top: 22px; */
}

.index-title {
  font-size: 1.7rem;
  color: #00e4ff;
  margin-left: 12px;
  font-weight: bold;
  width: 345px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.tab-content {
  display: flex;
  color: #0e688c;
  font-size: 1.8rem;
  height: 63%;
  align-items: center;
  margin-left: 20px;
}

.tab-content .tab-item {
  margin-left: 15px;
  position: relative;
  display: flex;
  user-select: none;
  font-size: 1rem;
  cursor: pointer;
}

.selectColor {
  color: #0ff;
}

.traImg {
  position: absolute;
  bottom: -0.8vw;
  width: 100%;
}

.right-box {
  position: absolute;
  right: 32px;
  top: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.dateBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  color: aqua;
  margin-right: 1vw;
  font-size: 0.7rem;
}

@keyframes show {
  0% {
    /* opacity: 0; */
    /* bottom: 2px; */
    width: 0;
  }

  100% {
    /* opacity: 1; */
    /* bottom: 0; */
    width: 100%;
  }
}

@keyframes hide {
  0% {
    /* opacity: 1; */
    width: 100%;
  }

  100% {
    /* opacity: 0; */
    width: 0;
  }
}

.show-enter-active {
  animation: show 0.8s;
}

.show-leave-active {
  animation: hide 0.8s;
}
</style>
